import { Component, OnInit } from '@angular/core';
import { TenantService } from '../../core/tenant/tenant.service';

@Component({
  selector: 'kt-safari-browser-warning',
  templateUrl: './safari-browser-warning.component.html',
  styleUrls: ['./safari-browser-warning.component.scss']
})
export class SafariBrowserWarningComponent implements OnInit {

  constructor(
    public tenant: TenantService
  ) { }

  ngOnInit(): void {
  }

}
